import {
  Alert,
  Box,
  Container,
  Paper,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import Header from '../components/Header';
import { useParams } from 'react-router-dom';
import { useChurch } from '../hooks/useChurch';
import { getTranslationURL } from '../util/getTranslationURL';
import { ServiceLink } from '../components/ServiceLink';
import { buildRoute, PageRoutes } from '../routes';
import { BackLink } from '../components/BackLink';

const ChurchQRPage = () => {
  const { churchId } = useParams<string>();
  const { church, error: churchError } = useChurch(churchId);

  if (!churchId) {
    return <Text>Missing churchId</Text>;
  }

  return (
    <main>
      <Header />
      <Box bg='linear-gradient(135deg, rgba(20, 33, 61, 0.08) 0%, rgba(13, 110, 253, 0.12) 100%)' py={{ base: 40, md: 72 }}>
        <Container size='xl' px={{ base: 'md', md: 'xl' }}>
          <Stack gap='lg'>
            <BackLink to={buildRoute(PageRoutes.CHURCH_PAGE, { churchId })} label='Back to services' />

            <Stack gap='sm'>
              <Title order={2}>Static QR code for {church?.name}</Title>
              <Text size='sm' c='dimmed'>
                Print or display this code to route attendees to the live translation page for today’s service. For
                specific events, generate the QR code from that service’s detail page instead.
              </Text>
            </Stack>

            {churchError && (
              <Alert title='Error loading church' color='red' radius='md'>
                {churchError}
              </Alert>
            )}

            <Paper radius='lg' p='lg' shadow='md' withBorder>
              <ServiceLink url={getTranslationURL(churchId, 'current')} churchName={church?.name || ''} />
            </Paper>
          </Stack>
        </Container>
      </Box>
    </main>
  );
};

export default ChurchQRPage;
